import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";

import getCardStatus from "./lib/getCardStatus";
import changeCardStatus from "./lib/changeCardStatus";

export default function CardStatus() {
  const [showOverlay, setShowOverlay] = useState(true);
  const [cardStatus, setCardStatus] = useState(null);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState(false);

  useEffect(() => {
    getCardStatus(setShowOverlay, setCardStatus, setError, setMessage);
  }, []);

  if (error)
    return (
      <div className="orenda-frontend">
        <div className="loader message">
          <p>Unfortunately an error occured.</p>
        </div>
      </div>
    );

  if (showOverlay)
    return (
      <div className="orenda-frontend">
        <div className="loader spinner">
          <ClipLoader size={20} />
          <span className="message">Please wait...</span>
        </div>
      </div>
    );

  if (message)
    return (
      <div className="orenda-frontend">
        <div className="status-message">{message}</div>
      </div>
    );

  function applyBtn(requestedStatus) {
    return changeCardStatus(
      setShowOverlay,
      setMessage,
      setError,
      requestedStatus,
      setCardStatus
    );
  }

  // - "Not Active"
  // - "Active"
  // - "Deposit Only"
  // - "Closed"
  // - "Unavailable"

  if (cardStatus === "Deposit Only") {
    return (
      <div className="orenda-frontend">
        <span className="message">Your card is Blocked.</span>
        <Button onClick={() => applyBtn("Unblock")} variant="link">
          Activate
        </Button>
      </div>
    );
  }

  if (cardStatus === "Active") {
    return (
      <div className="orenda-frontend">
        <span className="message">Your card is Active.</span>
        <Button onClick={() => applyBtn("Block")} variant="link">
          Block
        </Button>
      </div>
    );
  }

  return (
    <div className="orenda-frontend">
      <span className="message">
        Unfortunately you aren't currently able to change your card status.
      </span>
    </div>
  );
}
